import React from 'react';

import {
  Alert,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from '@mui/material';

import { IIPENNotaryState } from '../../redux-store/ipenNotary/ipenNotaryTypes';
import {
  formatDate,
  formatPartyName,
  phoneObjToString,
} from '../../utils/helpers';

interface IProps {
  notary?: IIPENNotaryState['notary'];
}

export default function NotaryInfo(props: IProps) {
  const { notary } = props;
  return (
    <div>
      <Alert
        severity='info'
        sx={{
          width: '80%',
          mx: 'auto',
        }}>
        Please review the information below and confirm it&rsquo;s correct
        before continuing. You will not be allowed to assign a different notary
        once the session is launched.
      </Alert>
      <TableContainer
        sx={{
          my: 4,
          width: '80%',
          mx: 'auto',
        }}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell component='th' scope='row'>
                <Typography variant='subtitle1' sx={{ fontWeight: 600 }}>
                  Notary Name
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant='body1'>
                  {formatPartyName(
                    {
                      FirstName: notary?.FirstName,
                      LastName: notary?.LastName,
                      MiddleName: notary?.MiddleName,
                      Suffix: notary?.Suffix,
                    },
                    'non-signer'
                  )}
                </Typography>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell component='th' scope='row'>
                <Typography variant='subtitle1' sx={{ fontWeight: 600 }}>
                  Commission Number
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant='body1'>
                  {notary?.CommissionNumber}
                </Typography>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell component='th' scope='row'>
                <Typography variant='subtitle1' sx={{ fontWeight: 600 }}>
                  State
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant='body1'>
                  {notary?.CommissionState}
                </Typography>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell component='th' scope='row'>
                <Typography variant='subtitle1' sx={{ fontWeight: 600 }}>
                  County
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant='body1'>
                  {notary?.CommissionCounty}
                </Typography>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell component='th' scope='row'>
                <Typography variant='subtitle1' sx={{ fontWeight: 600 }}>
                  Commission Expiration Date
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant='body1'>
                  {formatDate(
                    notary?.CommissionExpirationDate,
                    'ddd, MMM Do, YYYY'
                  )}
                </Typography>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell component='th' scope='row'>
                <Typography variant='subtitle1' sx={{ fontWeight: 600 }}>
                  Email
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant='body1'>{notary?.Email}</Typography>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell component='th' scope='row'>
                <Typography variant='subtitle1' sx={{ fontWeight: 600 }}>
                  Cell Phone
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant='body1'>
                  {notary?.PhoneNumber
                    ? phoneObjToString(notary?.PhoneNumber)
                    : ''}
                </Typography>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
